import React from 'react'
import { ReactComponent as NameLogo } from '../assets/NameLogo.svg';

const Splash = () => {
  return (
        <NameLogo className='h-20' />
  )
}

export default Splash